
const ToggleSwitch = ({ label, checked, onChange, id, tooltip, disabled: _disabled, error }) => (
  <div className="proposal-toggle-row m-0">
    <label className="proposal-toggle" htmlFor={id}>
      <span>
        {label}
        {tooltip && (
          <span className="proposal-tooltip" title={tooltip}>
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.3125 0C5.86623 0 4.45243 0.428871 3.2499 1.23238C2.04736 2.03589 1.1101 3.17794 0.556634 4.51413C0.00316839 5.85031 -0.141643 7.32061 0.140511 8.7391C0.422665 10.1576 1.11911 11.4605 2.14178 12.4832C3.16446 13.5059 4.46742 14.2023 5.8859 14.4845C7.30439 14.7666 8.77469 14.6218 10.1109 14.0684C11.4471 13.5149 12.5891 12.5776 13.3926 11.3751C14.1961 10.1726 14.625 8.75877 14.625 7.3125C14.623 5.37373 13.8519 3.51496 12.481 2.14404C11.11 0.773127 9.25127 0.00204737 7.3125 0ZM7.3125 13.5C6.08873 13.5 4.89244 13.1371 3.87491 12.4572C2.85738 11.7773 2.06432 10.811 1.596 9.68035C1.12768 8.54974 1.00515 7.30564 1.24389 6.10538C1.48264 4.90512 2.07194 3.80261 2.93728 2.93728C3.80262 2.07194 4.90512 1.48264 6.10538 1.24389C7.30564 1.00514 8.54974 1.12768 9.68036 1.596C10.811 2.06431 11.7773 2.85738 12.4572 3.87491C13.1371 4.89244 13.5 6.08873 13.5 7.3125C13.4981 8.95296 12.8456 10.5257 11.6857 11.6857C10.5257 12.8456 8.95296 13.4981 7.3125 13.5ZM8.4375 10.6875C8.4375 10.8367 8.37824 10.9798 8.27275 11.0852C8.16726 11.1907 8.02419 11.25 7.875 11.25C7.57663 11.25 7.29049 11.1315 7.07951 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.3125C6.60082 7.3125 6.45774 7.25324 6.35225 7.14775C6.24677 7.04226 6.1875 6.89918 6.1875 6.75C6.1875 6.60081 6.24677 6.45774 6.35225 6.35225C6.45774 6.24676 6.60082 6.1875 6.75 6.1875C7.04837 6.1875 7.33452 6.30603 7.5455 6.517C7.75648 6.72798 7.875 7.01413 7.875 7.3125V10.125C8.02419 10.125 8.16726 10.1843 8.27275 10.2898C8.37824 10.3952 8.4375 10.5383 8.4375 10.6875ZM6.1875 4.21875C6.1875 4.05187 6.23699 3.88874 6.3297 3.74999C6.42241 3.61123 6.55419 3.50309 6.70836 3.43923C6.86254 3.37536 7.03219 3.35866 7.19586 3.39121C7.35953 3.42377 7.50987 3.50413 7.62787 3.62213C7.74587 3.74013 7.82623 3.89047 7.85879 4.05414C7.89135 4.21781 7.87464 4.38746 7.81078 4.54164C7.74691 4.69581 7.63877 4.82759 7.50001 4.9203C7.36126 5.01301 7.19813 5.0625 7.03125 5.0625C6.80748 5.0625 6.59286 4.9736 6.43463 4.81537C6.2764 4.65714 6.1875 4.44253 6.1875 4.21875Z"
                fill="#4E4F50"
              />
            </svg>
          </span>
        )}
      </span>
     
     
      <div className="yes-no-group">
        <label className="radio-option">
          <input
            type="radio"
            name={id}
            checked={checked === true}
            onChange={() => onChange(true)}
          />
          <span className="radio-custom"></span>
          <span>Yes</span>
        </label>

        <label className="radio-option">
          <input
            type="radio"
            name={id}
            checked={checked === false}
            onChange={() => onChange(false)}
          />
          <span className="radio-custom"></span>
          <span>No</span>
        </label>
      </div>

    </label>
   {error && <p className="error-toggle-text">{error}</p>}
  </div>
);

export default ToggleSwitch